<template>
  <template v-if="counterparties.length"
    ><Item
      v-for="counterpartie in counterparties"
      :key="counterpartie.slug"
      :counterpartie="counterpartie"
  /></template>
  <div v-else :class="$style.empty">Нет контрагентов :(</div>
</template>

<script>
import Item from "./Item.vue";
export default {
  components: {
    Item,
  },
  computed: {
    counterparties() {
      return this.$store.state.counterparties.counterparties;
    },
  },
};
</script>

<style lang="scss" module>
.empty {
  text-align: center;
  padding: 2rem 0 0.5rem 0;
  color: $t-secondary;
}
</style>
